export default "__VITE_ASSET__DgyZVTOz__"